import axios from "axios";
import { toast } from "sonner";
import { docFromInvoice } from "@/lib/quoteDoc";
import { BACKEND_URL } from "@/lib/backendUrl";

const API = `${BACKEND_URL}/api`;

// Shared invoice send helpers built on a useQuotePrinter() instance
export function useInvoiceSender(printer, shop) {
  const sharePdf = (inv, text) => printer.sharePdf(docFromInvoice(inv, shop), { text, phone: inv.customer_phone, countryCode: shop.countryCode });

  const emailPdf = async (inv, text) => {
    const id = toast.loading("Preparing invoice PDF…");
    try {
      const { base64, filename } = await printer.pdfBase64(docFromInvoice(inv, shop));
      const { data } = await axios.post(`${API}/invoices/${inv.id}/email`, { message: text, pdf_base64: base64, filename });
      toast.success("Invoice emailed", { id, description: `Sent to ${data.to} with ${filename}` });
      return data;
    } catch (e) {
      const dt = e?.response?.data?.detail;
      toast.error("Email not sent", { id, description: typeof dt === "string" ? dt : Array.isArray(dt) ? dt.map((x) => x?.msg || JSON.stringify(x)).join("; ") : String(e?.message || e) });
      throw e;
    }
  };

  return { sharePdf, emailPdf };
}
